import SectionHeader from "./SectionHeader";

const edges = [
  { from: "核心主角 · 幕布", to: "前合作方 · L", rel: "合作→指认", cls: "bg-primary-100 text-primary-800" },
  { from: "核心主角 · 幕布", to: "关联账号 · 对照相", rel: "疑似同一矩阵", cls: "bg-accent-100 text-accent-900" },
  { from: "当事人 · L", to: "关联账号 · 对照相", rel: "口径冲突", cls: "bg-secondary-100 text-secondary-900" },
];

const focus = [
  {
    icon: "ri-question-answer-line",
    title: "功劳归属之争",
    text: "主角「幕布」是否独占合作成果，是引发「反差黑料主角是谁」这一追问的第一根引线。",
  },
  {
    icon: "ri-user-follow-line",
    title: "人设落差之争",
    text: "对外科普口径与私下行为相悖，反差黑料的「反差」二字正是争议焦点所在。",
  },
  {
    icon: "ri-node-tree",
    title: "账号归属之争",
    text: "多账号是否同属一人运营，关系线能否闭合，直接决定事件核心人物是单数还是复数。",
  },
];

export default function Relation() {
  return (
    <section id="relation" className="bg-background-100/70">
      <div className="mx-auto max-w-7xl px-4 md:px-6 py-12 md:py-16">
        <SectionHeader
          kicker="PART 04 · 关系与焦点"
          title="人物如何相连，争议集中在哪"
          desc="看懂「反差黑料当事人」之间怎么牵扯，也就看懂了争论为何越滚越大。以下关系为公开信息下的推测连线，非定论。"
        />

        <div className="grid grid-cols-1 lg:grid-cols-2 gap-6">
          {/* 关系连线 */}
          <div className="rounded-xl border border-background-200 bg-background-50 p-5 md:p-6">
            <h3 className="text-base md:text-lg font-semibold text-foreground-950 font-heading mb-4 inline-flex items-center gap-2">
              <i className="ri-share-forward-line text-primary-600 w-5 h-5 flex items-center justify-center" />
              公开口径下的关系连线
            </h3>
            <div className="space-y-3">
              {edges.map((e) => (
                <div key={e.rel} className="flex flex-wrap items-center gap-2 rounded-lg bg-background-100/70 border border-background-200 px-3 py-2.5 text-xs md:text-sm">
                  <span className="font-medium text-foreground-800 whitespace-nowrap">{e.from}</span>
                  <span className={`rounded-full px-2 py-0.5 text-[11px] font-medium ${e.cls}`}>{e.rel}</span>
                  <span className="font-medium text-foreground-800 whitespace-nowrap">{e.to}</span>
                </div>
              ))}
            </div>
            <p className="mt-4 text-xs leading-6 text-foreground-500 flex items-start gap-2">
              <i className="ri-alert-line text-accent-600 w-4 h-4 flex items-center justify-center mt-0.5 shrink-0" />
              以上连线依据公开截图与发言整理，仅反映「曾被如此讨论」，不构成事实认定。
            </p>
          </div>

          {/* 争议焦点 */}
          <div className="flex flex-col gap-4">
            {focus.map((f) => (
              <div key={f.title} className="rounded-xl border border-background-200 bg-background-50 p-4 md:p-5 flex gap-4">
                <span className="w-10 h-10 shrink-0 rounded-lg bg-accent-100 text-accent-800 flex items-center justify-center">
                  <i className={`${f.icon} text-lg w-5 h-5 flex items-center justify-center`} />
                </span>
                <div>
                  <h3 className="text-sm md:text-base font-semibold text-foreground-950 font-heading">{f.title}</h3>
                  <p className="mt-1.5 text-sm leading-6 text-foreground-600">{f.text}</p>
                </div>
              </div>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
}